import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  stickToBottom: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.appBar,
    '& .MuiBottomNavigationAction-root': {
      minWidth: 'auto',
      padding: '6px 0px',
    },
    '& .MuiBottomNavigationAction-label': {
      fontSize: '0.75rem',
    },
  },
}));

export default useStyles;
